import styled from "styled-components"
import {HiPlus} from "react-icons/hi"
import { useDispatch } from "react-redux"
import { addBosaltmaDataItem, addRouteItem, addYuklemeDataItem } from "../../../../../features/addLoad/addLoadSlice"
import { useSelector } from "react-redux"
import * as MdIcons from "react-icons/md"

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    color: ${({theme}) => theme.secondaryTextColor};
    cursor: pointer;
    .text{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        padding: 5px;
        background-color: var(--color-main) ;
        color: var(--color-dark);
        display: flex;
        /* flex-direction: column; */
        align-items: center;
        color: white;
        border-radius: 8px;
        font-size: 12px;
        svg{
            width: 20px;
            height: 20px;
            margin-right: 5px;
        }
    }
`

const AddMapRoute = ({order=2, type="yukleme",SelectLoadMap}) => {

  const {theme} = useSelector(state => state.layout)

  const dispatch = useDispatch()

  const handleClick = () => {
    
    if(type === "yukleme"){
      dispatch(addRouteItem({type: "yukleme" }))
    }

    if(type === "bosaltma"){
      dispatch(addRouteItem({type: "bosaltma" }))
    }
  }

  return (
    <Container theme={theme} SelectLoadMap={SelectLoadMap} onClick={handleClick}>
      <div className="text">
        <MdIcons.MdOutlineAddLocationAlt/>
         {type === "yukleme" ? "Yükleme": "Boşaltma"} <br/> Ekle
      </div>
    </Container>
  )
}

export default AddMapRoute